/* VicHoorn — required "Tamanho da haste" line item property guard.
 *
 * Products tagged `haste` render mandatory radio pills that submit the line item
 * property `properties[Tamanho da haste]` (NO real Shopify variant). This guard:
 *   - blocks any /cart/add submit (main product form, mobile sticky bar) while the
 *     radio group is empty, in the capture phase so it runs before the AJAX handlers;
 *   - shows / clears the inline error and focuses the first radio;
 *   - mirrors the chosen value into the sticky bar's hidden property input so the
 *     property travels with that separate form too.
 */
(() => {
  const PROP_NAME = 'properties[Tamanho da haste]';
  const INPUT_SEL = `input[type="radio"][name="${PROP_NAME}"]`;
  const CHECKED_SEL = `input[type="radio"][name="${PROP_NAME}"]:checked`;
  const MIRROR_SEL = `input[type="hidden"][name="${PROP_NAME}"][data-vh-haste-mirror]`;
  const WRAP_SEL = '[data-required-haste]';
  const PURCHASE_CONTROL_SEL = 'button[name="add"], .shopify-payment-button, .shopify-payment-button__button';

  const getInputs = () => Array.from(document.querySelectorAll(INPUT_SEL));

  const getCheckedInput = () => document.querySelector(CHECKED_SEL);

  const getFirstInput = () => getInputs()[0];

  const getMessage = (wrap) => wrap?.querySelector('.product-form__haste-error');

  const setError = (show, focus = false) => {
    const firstInput = getFirstInput();
    if (!firstInput) return;

    const wrap = firstInput.closest(WRAP_SEL);
    const message = getMessage(wrap);

    if (message) message.hidden = !show;
    if (wrap) wrap.classList.toggle('is-invalid', show);
    getInputs().forEach((input) => {
      input.setAttribute('aria-invalid', show ? 'true' : 'false');
    });

    if (show && focus) {
      firstInput.focus();
      if (typeof firstInput.scrollIntoView === 'function') {
        firstInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  };

  const syncMirrors = () => {
    const checkedInput = getCheckedInput();
    const value = checkedInput ? checkedInput.value : '';
    document.querySelectorAll(MIRROR_SEL).forEach((input) => {
      input.value = value;
    });
  };

  const isSelected = () => Boolean(getCheckedInput());

  const isCartAddForm = (form) =>
    form instanceof HTMLFormElement && typeof form.action === 'string' && form.action.indexOf('/cart/add') !== -1;

  const blockIfMissing = (event, focus = true) => {
    syncMirrors();

    if (isSelected()) return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    setError(true, focus);
    return true;
  };

  // Capture phase: runs before product-form.js / vh-product-sticky.js submit handlers,
  // so stopImmediatePropagation prevents their fetch from firing.
  document.addEventListener(
    'submit',
    (event) => {
      if (!getFirstInput()) return;
      if (!isCartAddForm(event.target)) return;

      blockIfMissing(event);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!getFirstInput()) return;
      if (!event.target.closest?.(PURCHASE_CONTROL_SEL)) return;

      blockIfMissing(event);
    },
    true
  );

  // Clear the error as soon as the customer picks a value, and keep mirrors in sync.
  document.addEventListener('change', (event) => {
    if (!event.target.matches?.(INPUT_SEL)) return;
    if (isSelected()) setError(false);
    syncMirrors();
  });

  // Keep mirrors aligned after Dawn re-renders product-info on variant change.
  document.addEventListener('product-info:loaded', syncMirrors);
  document.addEventListener('DOMContentLoaded', syncMirrors);
})();
